import React from 'react';

// Renders chat text with [label](path) links and **bold**. Internal paths call onLink(path).
export function renderChatText(text, onLink) {
  if (!text) return text;
  const parts = [];
  const re = /\[([^\]]+)\]\((\/[^)\s]+|https?:\/\/[^)\s]+)\)|\*\*([^*]+)\*\*/g;
  let last = 0;
  let m;
  let k = 0;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    if (m[3] !== undefined) {
      parts.push(<strong key={`b${k++}`} className="font-semibold">{m[3]}</strong>);
    } else if (m[2].startsWith('/')) {
      const path = m[2];
      parts.push(
        <button
          key={`l${k++}`}
          onClick={() => onLink && onLink(path)}
          data-testid="chat-product-link"
          className="text-alp-gold underline underline-offset-2 decoration-alp-gold/50 hover:text-alp-goldlight hover:decoration-alp-gold transition-colors font-medium"
        >
          {m[1]}
        </button>
      );
    } else {
      parts.push(
        <a key={`l${k++}`} href={m[2]} target="_blank" rel="noopener noreferrer" className="text-alp-gold underline underline-offset-2 hover:text-alp-goldlight">
          {m[1]}
        </a>
      );
    }
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}
